import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {LogserviceService} from '../logservice/logservice.service';
import { httpGetOptions, httpJsonPostOptions } from '../../../Util';
const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type':  'application/json',
      //'Access-Control-Allow-Origin': '*',
      'Cache-Control': 'private, max-age=1200'
  })
};

const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class QueryProcessorService{

  constructor(private httpClient:HttpClient ,private logService:LogserviceService) { }

    httpHeaders = new HttpHeaders();
    backendUrl = environment.apiURL;

    getQueriesService(id): Observable<any> {
        this.logService.logMessage('getQueriesService', 'debug');
        return this.httpClient.get(this.backendUrl + 'query/getFilters/'+id, httpOptions).pipe(retry(2), catchError(this.handleError));
    }

    searchQueriesService(payload): Observable<any> {
      this.logService.logMessage('searchQueriesService', 'debug');
      return this.httpClient.post(this.backendUrl + 'query/run', payload, httpOptions).pipe(retry(2), catchError(this.handleError));
    }
    public getPergeCache():Observable<any>
    {
      return this.httpClient.get(this.backendUrl+"flushJsonStructure").pipe(retry(2),catchError(this.handleError));
    }

    markAsCase(id:number): Observable<any> {      
      return this.httpClient.get(this.backendUrl + 'custom/moveToTriage/'+id, httpOptions).pipe(retry(2), catchError(this.handleError));
    }
    getLookupName(id,enityName): Observable<any>{
      return this.httpClient.get(this.backendUrl + 'page/entity/lookup/'+enityName+'/'+id,{ headers, responseType: 'text'});
     }
     delete(entityName,id){
      return this.httpClient.delete(this.backendUrl + 'entity/'+entityName+'/'+id).pipe(retry(2), catchError(this.handleError));
    }
    getQueriesServiceV2(id): Observable<any> {
      this.logService.logMessage('getQueriesService', 'debug');
      return this.httpClient.get(this.backendUrl + 'query/v2/getFilters/'+id, httpGetOptions).pipe(retry(2), catchError(this.handleError));
  }
    private handleError(errorObj: HttpErrorResponse | any) {
      const _self = this;
      let errorMessage: string;
      let body: any;
      if (errorObj instanceof HttpErrorResponse) {
          if (errorObj.ok === false && errorObj.status === 0) {
              errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime.';
          } else {
              body = errorObj.error || '';
              errorMessage = body.message ? body.message : body.error.message;
          }
      }
      return throwError(errorMessage);
  }


}
